import TargetsRemap from "./TargetsRemap";

export default TargetsRemap;
